export const ASSETS_BUILD_PATH = process.env.ASSETS_BUILD_PATH;